import {css, cx} from "@panda/css";

import {getRankingBadgeForOffer} from "../utils/get_ranking_badge_for_offer";
import {getRankingBadgeImageSrc} from "../utils/ranking_badge_image_sources";

interface IProps {
    offerId: number;
    className?: string;
}

export function RankingOfferBadge(props: IProps) {
    const {offerId, className} = props;

    const badge = getRankingBadgeForOffer(offerId);
    const src = badge && getRankingBadgeImageSrc(badge.year, badge.variant);

    if (!src) {
        return null;
    }

    return <img src={src} alt="" className={cx(rankingOfferBadgeImgStyle, className)} aria-hidden />;
}

const rankingOfferBadgeImgStyle = css({
    position: "absolute",
    top: 1.5,
    right: 1.5,
    zIndex: 4,
    maxWidth: "9rem",
    width: "auto",
    height: "auto",
    pointerEvents: "none"
});
import {css, cx} from "@panda/css";

import {getRankingBadgeForOffer} from "../utils/get_ranking_badge_for_offer";
import {getRankingBadgeImageSrc} from "../utils/ranking_badge_image_sources";

interface IProps {
    offerId: number;
    className?: string;
}

export function RankingOfferBadge(props: IProps) {
    const {offerId, className} = props;

    const badge = getRankingBadgeForOffer(offerId);
    const src = badge && getRankingBadgeImageSrc(badge.year, badge.variant);

    if (!src) {
        return null;
    }

    return <img src={src} alt="" className={cx(rankingOfferBadgeImgStyle, className)} aria-hidden />;
}

const rankingOfferBadgeImgStyle = css({
    position: "absolute",
    top: 1.5,
    right: 1.5,
    zIndex: 4,
    maxWidth: "9rem",
    width: "auto",
    height: "auto",
    pointerEvents: "none"
});
